import React from "react";
import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext
} from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
import { ReactComponent as ArrowIcon } from "./arrow.svg";
import InstagramMedia from "src/components/utils/InstagramMedia";
import styles from "./index.module.css";

class Carousel extends React.Component {
  render() {
    return (
      <CarouselProvider
        className={styles.Carousel}
        visibleSlides={this.props.visibleSlides}
        totalSlides={this.props.images.length}
        step={4}
        moveThreshold={100}
        naturalSlideWidth={400}
        naturalSlideHeight={400}>
        <ButtonBack className={styles.back}>
          <ArrowIcon
            style={{
              height: "100%",
              transform: "rotate(90deg)",
              fill: this.props.theme === "black" ? "white" : "black"
            }}
          />
        </ButtonBack>
        <div className={styles.slider}>
          <Slider>
            {this.props.images.map(image => (
              <InstagramMedia
                media={image}
                render={({ image }) => (
                <Slide key={image.id} className={styles.slide} onClick={() => this.props.onChange(image)}>
                        <img src={image.media_url} alt="" />
                </Slide>
                )}
              />
            ))}
          </Slider>
        </div>
        <ButtonNext className={styles.next}>
          <ArrowIcon
            style={{
              height: "100%",
              transform: "rotate(-90deg)",
              fill: this.props.theme === "black" ? "white" : "black"
            }}
          />
        </ButtonNext>
      </CarouselProvider>
    );
  }
}

class Images extends React.Component {
  state = { currentImage: this.props.images[0] };
  render() {
    const { images = [], visibleSlides = 4, theme = 'black' } = this.props;
    const { currentImage } = this.state;

    return images.length ? (
      <div className={styles.Images}>
        <div className={styles.list}>
          <Carousel
              images={images}
              visibleSlides={visibleSlides}
              theme={theme}
              onChange={image => this.setState({ currentImage: image })}
          />
        </div>
        <div className={styles.main}>
          <InstagramMedia
            media={currentImage}
            render={({ image }) => (
              <div>
                  <a
                     href={image.carouselRootPermalink == null ? image.permalink : image.carouselRootPermalink}
                     target="_blank"
                     rel="noopener noreferrer"
                  >
                  <img src={image.media_url} alt="" />
                  </a>
              </div>
            )}
          />
        </div>
      </div>
    ) : null;
  }
}

export default Images;
